import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Login({ onLogin, branding }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/login', {
        email,
        password
      });

      onLogin(response.data.token, response.data.user);
    } catch (err) {
      // Handle specific error messages from the server
      const errorMessage = err.response?.data?.error || 'Login failed. Please try again.';
      
      // Check if account is deactivated (403 status code)
      if (err.response?.status === 403) {
        setError('Your account has been deactivated. Please contact support for assistance.');
      } else {
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        {branding.logo_url && (
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '2rem',
            paddingBottom: '2rem',
            borderBottom: '2px solid #f0f0f0'
          }}>
            <img 
              src={branding.logo_url} 
              alt={branding.company_name}
              style={{
                maxWidth: '400px',
                width: '100%',
                height: 'auto'
              }}
            />
          </div>
        )}
        <div className="auth-header">
          <h1 className="auth-title">Welcome Back</h1>
          <p className="auth-subtitle">Sign in to access your health & safety documents</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your.email@company.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-footer">
          Don't have an account? <Link to="/request-access" className="auth-link">Request access</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
